import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isAuthenticated: false,
    user: {},
    isAdmin: false,
    isStudent: false
}

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {

        login(state, action) {
            state.user = { ...state.user, ...action.payload };
            state.isAuthenticated = true;
        },
        logout(state) {
            state.user = {};
            state.isAuthenticated = false;
        },
        setInitial(state, action) {
            state.user = Object.assign({}, ...action.payload.claims.map(x => { return { [x.type]: x.value } }));;
            state.isAdmin = action.payload.user.isAdmin;
            state.isAuthenticated = action.payload.isAuth;
            state.isStudent = state.user.isstudent == 'Yes' ? true : null
            state.fetchAuthFinish=true;
        }
    }
})

export const authActions = authSlice.actions;
export default authSlice
